import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './empStyle.css';
import config from '../../config.json';
import EmpLabel from './EmpLabel';

const apiUrl = config.apiUrl;

const EmpDelete = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [employee, setEmployee] = useState({
        IDNumber: '',
        LastName: '',
        FirstName: '',
        MiddleInitial: '',
        Position: '',
        User: [],
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { employeeId } = useParams();

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Employee/${employeeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                if (!response.ok) {
                    if (response.status === 401) {
                        // Redirect to login page if unauthorized
                        window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                    } else {
                        // Handle other error cases
                        setErrorMessage('Failed to fetch data');
                        setSuccessMessage('');
                    }
                    return;
                }

                setEmployee({
                    IDNumber: data.Details.IdNumber,
                    LastName: data.Details.LastName,
                    FirstName: data.Details.FirstName,
                    MiddleInitial: data.Details.MiddleInitial,
                    Position: data.Details.Position,
                    User: data.Details.User,
                    Status: data.Details.Status,
                    CreatedBy: data.Details.CreatedBy,
                    CreatedDate: data.Details.CreatedDate,
                    UpdatedBy: data.Details.UpdatedBy,
                    UpdatedDate: data.Details.UpdatedDate,
                });
            } catch (error) {
                setErrorMessage("delete error");
                setSuccessMessage('');
            }
        };


        if (employeeId) {
            fetchEmployeeData();
        }
    }, [employeeId]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Employee/Delete/${employeeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage(data.Message);
                    setSuccessMessage('');
                    return
                }
            }

            setSuccessMessage(data.Message);
            setErrorMessage('');
            navigate('/employee-list');
        } catch (error) {
            setErrorMessage('delete error');
            setSuccessMessage('');
        }
    };

    const { IDNumber, LastName, FirstName, MiddleInitial, Position, User, Status, CreatedBy, CreatedDate, UpdatedBy, UpdatedDate } = employee;

    return (
        <div>
            {userAccess.hasAdmin ? (
                <>
                    <h3>Delete Employee</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleDelete}>
                        <div className="row mt-4">
                            <div className="col-md-6">
                                <EmpLabel label="ID Number" value={IDNumber} />
                                <EmpLabel label="First Name" value={FirstName} />
                                <EmpLabel label="Middle Name" value={MiddleInitial} />
                                <EmpLabel label="Last Name" value={LastName} />
                                <EmpLabel label="First Name" value={FirstName} />
                                <EmpLabel label="Position" value={Position} />
                                <EmpLabel label="User" value={User.Email} />
                            </div>
                            <div className="col-md-6">
                                <EmpLabel label="Status" value={Status} />
                                <EmpLabel label="Created By" value={CreatedBy} />
                                <EmpLabel label="Created Date" value={CreatedDate} />
                                <EmpLabel label="Updated By" value={UpdatedBy} />
                                <EmpLabel label="Updated Date" value={UpdatedDate} />
                            </div>
                        </div>

                        <div className="mb-2">
                            <Link to="/employee-list" className="btn btn-secondary me-2">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <button type="submit" className="btn btn-primary">Delete</button>
                            )}
                        </div>

                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    )
}

export default EmpDelete